import styled from 'styled-components';
import { color } from 'styles/settings';

export const Container = styled.div`
  background-color: ${color.neutral.grayLighter};
  width: 100vv;
  height: 100vh;
`;
